package cc.bluepeak.clubmanager.site.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.silk.style.CssStyle

val SecondaryParagraph = CssStyle {
    base {
        Modifier.lineHeight(1.4)
            .fontWeight(400)
            .color(Theme.secondary)
    }
}